import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import { addClass, removeClass } from '../../utils/classHelpers'

import '../../css/modals.css'

class Modal extends Component {
    constructor(props){
        super(props)
        this.state = {
            modalRoot: document.getElementById('modal-root'),
            element: document.createElement('div')
        }
    }

    componentWillMount(){
        this.state.modalRoot.appendChild(this.state.element)
        addClass([document.body], 'modal-open')
    }
    compo

    componentWillUnmount(){
        this.state.modalRoot.removeChild(this.state.element)
        removeClass([document.body], 'modal-open')
    }

    render() {
        return ReactDOM.createPortal(
            <div className="modal">
                <div className="dialog">
                    <div className="dialog-header">{this.props.title}</div>
                    <div className="dialog-body">
                        <div className="hbs-dialog-content">{this.props.children}</div>
                    </div>
                    <div className="dialog-footer">
                        {this.props.buttons.map((button, i) => <button.type key={i} { ...button } /> )}
                    </div>
                </div>
            </div>,
            this.state.element
        )
    }
}

Modal.propTypes = {
    title: PropTypes.string.isRequired
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/modal/Modal.js